import { useState, useEffect } from 'react';
// Button removed - causes production crash
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Globe, Check } from 'lucide-react';
import { useCurrency } from '../contexts/CurrencyContext';
import { toast } from 'sonner';

const SUPPORTED_CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', flag: '🇺🇸' },
  { code: 'SAR', symbol: 'SAR', name: 'Saudi Riyal', flag: '🇸🇦' },
  { code: 'AED', symbol: 'AED', name: 'UAE Dirham', flag: '🇦🇪' }
];

export default function CurrencySelector({ variant = "default", showLabel = true }) {
  const { currency, setCurrency, isLoading } = useCurrency();

  const handleCurrencyChange = async (currencyCode) => {
    await setCurrency(currencyCode);
    const selectedCurrency = SUPPORTED_CURRENCIES.find(c => c.code === currencyCode);
    toast.success(`Currency changed to ${selectedCurrency.name}`);
  };

  if (isLoading) {
    return (
      <button variant="ghost" disabled size="sm">
        <Globe className="w-4 h-4 mr-2" />
        Loading...
      </button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button variant={variant} size="sm" className="gap-2">
          <Globe className="w-4 h-4" />
          {showLabel && (
            <>
              <span className="font-semibold text-xs">{currency.symbol}</span>
              {currency.code !== currency.symbol && (
                <span className="text-xs">{currency.code}</span>
              )}
            </>
          )}
          {!showLabel && (
            <span className="font-semibold text-xs">{currency.code}</span>
          )}
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-64 bg-gray-800 border-purple-500/30">
        <DropdownMenuLabel className="text-gray-300">
          Select Currency
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-purple-500/30" />

        {SUPPORTED_CURRENCIES.map((curr) => (
          <DropdownMenuItem
            key={curr.code}
            onClick={() => handleCurrencyChange(curr.code)}
            className="cursor-pointer hover:bg-purple-600/20 text-gray-200 focus:bg-purple-600/30 focus:text-white"
          >
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-3">
                <span className="text-xl">{curr.flag}</span>
                <div>
                  <div className="font-semibold text-white">
                    <span className="text-xs">{curr.symbol}</span> {curr.code !== curr.symbol && <span className="text-sm">{curr.code}</span>}
                  </div>
                  <div className="text-xs text-gray-400">{curr.name}</div>
                </div>
              </div>
              {currency.code === curr.code && (
                <Check className="w-4 h-4 text-green-500" />
              )}
            </div>
          </DropdownMenuItem>
        ))}

        <DropdownMenuSeparator className="bg-purple-500/30" />

        <div className="px-2 py-2">
          <div className="text-xs text-gray-400 text-center">
            💡 Prices auto-detected from your location
          </div>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
